import React, { forwardRef, useRef } from 'react'
import SingleAnnouncement, {
  ISingleAnnouncementData,
} from 'src/components/sections/announcements/SingleAnnouncement'
import SectionHeader from 'src/components/ui/SectionHeader'
import { announcementsAnimations } from 'src/components/sections/announcements/animations'
import { gsap } from 'gsap/all'

export interface IAnnouncementsProps {
  translationContent: {
    sectionName: string
    subtitle: string
    action: string
  }
  announcements: ISingleAnnouncementData[]
}

const Announcements = forwardRef<HTMLDivElement, IAnnouncementsProps>(
  (
    { translationContent: { subtitle, action, sectionName }, announcements },
    ref
  ) => {
    const timeline = useRef(gsap.timeline())
    const subtitleRef = useRef<HTMLDivElement>(null)

    announcementsAnimations(timeline.current, subtitleRef)

    return (
      <section
        ref={ref}
        data-name={sectionName}
        id={sectionName}
        className="container py-20 md:py-32 bg-transparent"
      >
        <SectionHeader
          subtitle={subtitle}
          titlePart1={sectionName}
          titlePart2=""
          subtitleRef={subtitleRef}
          className="mb-12 md:mb-20"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {announcements.map(
            ({ status, location, position, requirements, mailSubject }, index) => (
              <SingleAnnouncement
                key={`${position}-${location}-${index}`}
                timeline={timeline.current}
                action={action}
                status={status}
                location={location}
                position={position}
                requirements={requirements}
                mailSubject={mailSubject}
              />
            )
          )}
        </div>
      </section>
    )
  }
)

export default Announcements
